// import zoombt from '../assets/css/zoom/zoom-bootstrap.useable.css'
// import zoomrs from '../assets/css/zoom/zoom-react-select.useable.css'
//import zoomrs from '../assets/css/app.css'
import { Notification } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import Vue from "vue";
import VueRouter from "vue-router";
import {
  findRouteNameByPath,
  manageMainLayoutConfig,
  getToken,
  setToken,
  getRedirectUrl,
  setRedirectUrl,
  canTurnTo,
  getConfigValueByKey
} from "@/libs/util";
import Layout from "../views/main/main.vue";
import store from "@/store";
import { hasOneOf } from "@/libs/tools";
import config from "@/config";
const { mobApps } = config;

//const

const externalPages = [
  "login",
  "register",
  "activation",
  "certificate",
  "forgot",
  "directLogin",
  "directLoginCourse",
  "localSave",
  "recover",
  "ipomLandings",
  "notfound",
  "ezam_transit_check",
];

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "_home",
    redirect: "/home",
    component: Layout,
    meta: {
      login: true,
      hideInMenu: false
    }
    // children: [{
    //     path: 'home',
    //     name: 'home',
    //     meta: {
    //       login: true,
    //       hideInMenu: false,
    //       title: 'Эхлэл',
    //       notCache: true,
    //       icon: 'mdi-file-document-outline',
    //     },
    //     component: () => import("../views/home"),
    //   },
    //   {
    //     path: 'settings/:mode',
    //     name: 'settings',
    //     meta: {
    //       login: true,
    //       hideInMenu: true,

    //       title: 'Эхлэл',
    //       notCache: true,
    //       icon: 'mdi-file-document-outline',
    //     },
    //     component: () => import("../views/modules/sys/settings"),
    //   },
    //   {
    //     path: 'notification',
    //     name: 'notification',
    //     meta: {
    //       login: true,
    //       hideInMenu: true,

    //       title: 'Эхлэл',
    //       notCache: true,
    //       icon: 'mdi-file-document-outline',
    //     },
    //     component: () => import("../views/modules/sys/notification"),
    //   },
    //   {
    //     path: 'media/home',
    //     name: 'mediaHome',
    //     meta: {
    //       login: true,
    //       hideInMenu: false,
    //       access: ['media'],
    //       title: 'Динамик драйв',
    //       notCache: true,
    //       icon: 'mdi-file-document-outline',
    //     },
    //     component: () => import("../views/modules/media"),
    //   },
    // ]
  },

  
  {
    path: "/",
    name: "_master",
    //redirect: '/home',
    component: () => import("../views/main/main.vue"),

    children: [
      {
        path: "/login",
        name: "login",
        meta: {
          login: false,
          hideInMenu: true
        },
        component: () => import("../views/auth/login")
      },
      {
        path: "/dl/:token",
        name: "directLogin",
        meta: {
          login: false,
          hideInMenu: true
        },
        component: () => import("../views/auth/directLogin")
      },

      {
        path: "/dc/:token/:url",
        name: "directLoginCourse",
        meta: {
          login: false,
          hideInMenu: true
        },
        component: () => import("../views/auth/directLoginCourse")
      },

      {
        path: "/ls/:nm/:prm/:rt",
        name: "localSave",
        meta: {
          login: false,
          hideInMenu: true
        },
        component: () => import("../views/auth/localSave")
      },
      {
        path: "/register",
        name: "register",
        meta: {
          login: false,
          hideInMenu: true
        },
        component: () => import("../views/auth/register")
      },
      {
        path: "/forgot",
        name: "forgot",
        meta: {
          login: false,
          hideInMenu: true
        },
        component: () => import("../views/auth/forgot")
      },
      {
        path: "/recover/:pk",
        name: "recover",
        meta: {
          login: false,
          hideInMenu: true
        },
        component: () => import("../views/auth/recover")
      },
      {
        path: "/activation/:u",
        name: "activation",
        meta: {
          login: false,
          hideInMenu: true
        },
        component: () => import("../views/auth/activation")
      },
      {
        path: "/certificate",
        name: "certificate",
        meta: {
          login: false,
          hideInMenu: true
        },
        component: () => import("../views/auth/certificate")
      },
      {
        path: "/ezam_transit_check/:p",
        name: "ezam_transit_check",
        meta: {
          login: false,
          hideInMenu: true
        },
        component: () => import("../views/auth/ezam_transit_check")
      },
      
      //penaltyDashboard
      {
        path: "/penalty",
        name: "penaltyDashboard",
        component: () => import("../views/apps/penalty"),
        meta: {
          header: false,
          login: true
        }
      },

      {
        path: "/dan/authorized",
        name: "danAuthorized",
        meta: {
          login: true,
          hideInMenu: true
        },
        component: () => import("../views/auth/danAutherized")
      },
    ]
  },
  
  {
    path: "/404",
    name: "notfound",
    meta: {
      login: false,
      hideInMenu: true
    },
    component: () => import("../views/modules/sys/notfound")
  },
  {
    path: "/401",
    name: "permissionDenied",
    meta: {
      login: false,
      hideInMenu: true
    },
    component: () => import("../views/modules/sys/permissiondenied")
  },
  {
    path: "/lms/qrat/:cid/:lid",
    name: "qrAttendance",
    component: () => import("../views/modules/lms/student/pages/qrAttendance"),
    meta: {
      header: false,
      login: true
    }
  },
  // {
  //   path: "/lms/contact",
  //   name: "lmsContact",
  //   component: () => import("../views/modules/lms/student/pages/contact"),
  //   meta: {
  //     header: false,
  //     login: true
  //   }
  // },
  {
    path: "/landing/:id/:cid",
    name: "landingPage",
    component: () => import("../views/apps/web/index.vue"),
    meta: {
      header: false,
      login: false
    }
  },
  {
    path: "/sp/:id/:cid",
    name: "landingShuffle",
    component: () => import("../views/apps/shuffle/index.vue"),
    meta: {
      header: false,
      login: false
    }
  },
  {
    path: "/tads/:id/:cid",
    name: "landingTads",
    component: () => import("../views/apps/tads"),
    meta: {
      header: false,
      login: false
    }
  },
  {
    path: "/mnuac",
    name: "mnuac",
    component: () => import("../views/apps/mnuac"),
    meta: {
      header: false,
      login: false
    }
  },
  {
    path: "/ipom",
    name: "landingIpom",
    component: () => import("../views/apps/ipom"),
    meta: {
      header: false,
      login: false
    }
  },
  {
    path: "/ipoms/:lid",
    name: "ipomLandings",
    component: () => import("../views/apps/ipom/pages/search"),
    meta: {
      header: false,
      login: false
    }
  },
  {
    path: "/help/:id/:cid",
    name: "landingHelp",
    component: () => import("../views/apps/help"),
    meta: {
      header: false,
      login: false
    }
  },
  {
    path: "/exam/:courseId/:formId/:lessonId/:boxId/:boxOt",
    name: "examOnline",
    component: () => import("../views/main/exam.vue"),
    meta: {
      header: false,
      login: true
    }
  },
  {
    path: "/lms/learnSurvey/:id/:name",
    name: "lmsSurvey",
    component: () => import("../views/modules/form/sanalAsuulga"),
    meta: {
      header: false,
      login: true
    }
  },

  {
    path: "/examChart/:id/:ot/:cid/:lid",
    name: "examChart",
    component: () =>
      import("../components/task/components/dialogs/examChartInPage.vue"),
    meta: {
      header: false,
      login: true
    }
  },

  /*===================== VET MED  ==========================*/
  {
    path: "/vet-med",
    name: "vet-med",
    component: () => import("../views/apps/vet-med/landing/home.vue"),
    meta: {
      header: false,
      login: false
    }
  },
  {
    path: "/vet-landing-help/:cid/:id",
    name: "vetLandingHelp",
    component: () => import("../views/apps/vet-med/landing/help.vue"),
    meta: {
      header: false,
      login: false
    }
  },
  {
    path: "/vet-landing-meds",
    name: "vetLandingMeds",
    component: () => import("../views/apps/vet-med/landing/meds.vue"),
    meta: {
      login: false,
      hideInMenu: true,
      access: []
    }
  },
  {
    path: "/vet-landing-lics",
    name: "vetLandingLics",
    component: () => import("../views/apps/vet-med/landing/lics.vue"),
    meta: {
      login: false,
      hideInMenu: true,
      access: []
    }
  },

  /*===================== VET DRUG  ==========================*/
  {
    path: "/ia-vm-req",
    name: "_ia-vm-req",
    component: Layout,
    meta: {
      login: false,
      hideInMenu: true,
      access: []
    },
    children: [
      {
        path: "list/:ot",
        name: "vetMedList",
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: "Эхлэл",
          notCache: true,
          icon: "mdi-file-document-outline",
          ot: 463
        },
        component: () => import("../views/apps/vet-med/list.vue")
      },
      {
        path: "activemedcert/:ot",
        name: "vetMedMy",
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: "Эхлэл",
          notCache: true,
          icon: "mdi-file-document-outline",
          ot: 478
        },
        component: () => import("../views/apps/vet-med/list.vue")
      },
      {
        path: "law-db/:ot",
        name: "vetMedLaw",
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: "Эхлэл",
          notCache: true,
          icon: "mdi-file-document-outline",
          ot: 487
        },
        component: () => import("../views/apps/vet-med/list.vue")
      },
      {
        path: "law-juram/:ot",
        name: "vetMedJuram",
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: "Эхлэл",
          notCache: true,
          icon: "mdi-file-document-outline",
          ot: 488
        },
        component: () => import("../views/apps/vet-med/list.vue")
      },
      {
        path: "list/cert/:ot",
        name: "vetMedListCert",
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: "Эхлэл",
          notCache: true,
          icon: "mdi-file-document-outline",
          ot: 464
        },
        component: () => import("../views/apps/vet-med/list.vue")
      },
      {
        path: "list/lic/:ot",
        name: "vetMedLics",
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: "Эхлэл",
          notCache: true,
          icon: "mdi-file-document-outline",
          ot: 467
        },
        component: () => import("../views/apps/vet-med/list.vue")
      },
      {
        path: "list/req/:ot",
        name: "vetMedListReq",
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: "Эхлэл",
          notCache: true,
          icon: "mdi-file-document-outline",
          ot: 465
        },
        component: () => import("../views/apps/vet-med/list.vue")
      },
      {
        path: "medicine/:ot",
        name: "vetMedMedicine",
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: "Эхлэл",
          notCache: true,
          icon: "mdi-file-document-outline",
          ot: 472
        },
        component: () => import("../views/apps/vet-med/list.vue")
      },
      {
        path: "medicine-accepted-meds/:ot",
        name: "vetMedAcceptedMeds",
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: "Эхлэл",
          notCache: true,
          icon: "mdi-file-document-outline",
          ot: 477
        },
        component: () => import("../views/apps/vet-med/list.vue")
      },
      {
        path: "video-conference/:ot",
        name: "vidConference",
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: "Эхлэл",
          notCache: true,
          icon: "mdi-file-document-outline",
          ot: 493
        },
        component: () => import("../views/apps/vet-med/list.vue")
      },
      {
        path: "sys-reports/:ot",
        name: "sysReports",
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: "Эхлэл",
          notCache: true,
          icon: "mdi-file-document-outline",
          ot: 451
        },
        component: () => import("../views/modules/report")
      },
      {
        path: "medicine-accepted-org-license/:ot",
        name: "vetMedAcceptedOrgLicences",
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: "Эхлэл",
          notCache: true,
          icon: "mdi-file-document-outline",
          ot: 476
        },
        component: () => import("../views/apps/vet-med/list.vue")
      },
      {
        path: "medicine-accepted-samples/:ot",
        name: "vetMedAcceptedSamples",
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: "Эхлэл",
          notCache: true,
          icon: "mdi-file-document-outline",
          ot: 481
        },
        component: () => import("../views/apps/vet-med/list.vue")
      },
      {
        path: "list/special/:ot",
        name: "vetMedSpecial",
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: "Эхлэл",
          notCache: true,
          icon: "mdi-file-document-outline",
          ot: 468
        },
        component: () => import("../views/apps/vet-med/list.vue")
      },
      {
        path: "list/sample/:ot",
        name: "vetMedSample",
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: "Эхлэл",
          notCache: true,
          icon: "mdi-file-document-outline",
          ot: 479
        },
        component: () => import("../views/apps/vet-med/list.vue")
      },
      {
        path: "list/users/:ot",
        name: "vetMedUsers",
        props: true,
        meta: {
          login: true,
          hideInMenu: true,
          access: [],
          title: "Эхлэл",
          notCache: true,
          icon: "mdi-file-document-outline",
          ot: 138
        },
        component: () => import("../views/apps/vet-med/list.vue")
      }
    ]
  }
];

const router = new VueRouter({
  mode: "hash",
  //mode: 'history',
  routes
});

const turnTo = (to, access, next, withParam) => {
  // console.log('turnTo', to.name);
  let joinedRoutes = routes.concat(store.state.app.dynamicRoutes);
  store.dispatch("handleLoading", {
    isLoading: false
  });

  //console.log('next', store.state.app.isMobile && (
  //   window.location.host=='academy.golomtbank.com' ||
  //   window.location.host=='www.academy.golomtbank.com' ||
  //   window.location.host=='192.168.0.105'
  // ));
  //console.log("step 1")
  if (canTurnTo(to.name, access, joinedRoutes)) {
    //console.log("step 2", to)
    if (to.name == "login") manageMainLayoutConfig(to, store, true);
    else manageMainLayoutConfig(to, store);
    if (withParam != undefined && withParam)
      next({
        name: to.name,
        params: to.params
      });
    // else if(to.name == 'userProfile'){
    //   next({ name: to.name })
    // }
    else {      
      next();
    }
  } else {
    //console.log("step 3")
    manageMainLayoutConfig(to, store, true);
    next({
      replace: true,
      name: "permissionDenied"
    });
  }
};

const turnLogin = (to, next, withParam) => {
  //console.log("turnLogin duudav uu")
  //console.log("to", to);
  //console.log("next", next);
  //console.log("withParam", withParam);
  //console.log('turnLogin duudagsanuuu');
  store.dispatch("handleLoading", {
    isLoading: false
  });
  manageMainLayoutConfig(to, store, true, true);
  setToken("");
  if (withParam != undefined && withParam)
  {
    //console.log("asd",to);
    if(to.path!=undefined)
      setRedirectUrl(to.path);
    //cookie set redirect url 
    next({
      name: "login"
    });
  }
  else {
    //console.log("ene yum bolov uu",to.path)
    next();}
};

const turnProfile = (to, next) => {
  Notification.info({
    message: "Үндсэн мэдээлэл дутуу байна. Бөглөнө үү",
    title: "Мэдэгдэл",
    duration: 10000,
    type: "info",
    position: "top-right",
    offset: 50
  });
  store.dispatch("handleLoading", {
    isLoading: false
  });
  manageMainLayoutConfig(to, store, true, true);
  next({
    name: "userProfile"
  });
};

const turnInvoice = (to, next, id) => {
  //console.log('turnInvoice irle', id);
  // Notification.info({
  //   message: 'Үндсэн мэдээлэл дутуу байна. Бөглөнө үү',
  //   title: "Мэдэгдэл",
  //   duration: 10000,
  //   type: "info",
  //   position: 'top-right',
  //   offset: 50
  // });
  store.dispatch("handleLoading", {
    isLoading: false
  });
  manageMainLayoutConfig(to, store, true, true);
  next({
    name: "lmsPaymentDetail",
    params: { id: id }
  });
};


// window.popStateDetected = false
// window.addEventListener('popstate', () => {
//   window.popStateDetected = true
// })

router.beforeEach((to, from, next) => {
  // console.log(from);
  //console.log("beaforeEach:", from, to, next);

  // if(window.examBackDisabled && window.popStateDetected){
  //   //console.log('examBackDisabled',window.examBackDisabled);
  //   window.popStateDetected = false;
  //   next(false);
  //   return "";
  // }
  
  if (window.zoomBackDisabled) {
    Notification.info({
      message:
        "Дэлгэцийн баруун доод буланд байрлах Leave товч дээр дарж гарна уу",
      title: "Мэдэгдэл",
      duration: 6000,
      type: "info",
      position: "top-left",
      offset: 50
    });
    next(false);
    return "";
  }

  store.dispatch("handleLoading", {
    isLoading: true
  });
  store.dispatch("resetResponsiveLayoutConfig", document);
  //resetResponsiveLayoutConfig(store, document);

  const token = getToken();
  let host; //= mobApps.filter(x => x.id == mobAppActiveGroup)[0];
  if (process.env.NODE_ENV === "development") {
    let _host = mobApps.filter(
      x => x.hostDev != undefined && x.hostDev.includes(window.location.host)
    );
    if (_host.length) {
      host = _host[0];
    } else {
      //alert("dsfsd debug");
    }
  } else {
    let _host = mobApps.filter(
      x => x.hostPro != undefined && x.hostPro.includes(window.location.host)
    );
    if (_host.length) {
      host = _host[0];
    } else {
      //alert("dsfsd prod");
      host = mobApps.filter(
        x =>
          x.hostPro != undefined && x.hostPro.includes("academy.golomtbank.com")
      )[0];
    }
  }

  // console.log('store.state.app.activeGroup', store.state.app)
  if (store.state.app.activeGroup) {
    store.dispatch("handleActiveGroup", host);
  }

  //console.log('token', !token);
  if (!token) {
    //console.log('host.publicPage', host.publicPage);
    if (host.publicPage != undefined && host.publicPage.has) {
      //console.log("publicPage has 1")
      store
        .dispatch("handleJWT", {
          key: host.key
        })
        .then(JWT => {
          //console.log("publicPage has 1_1")
          if (JWT != false) {
            store
              .dispatch("handlePages", {
                store: store
              })
              .then(page => {
                if (page != false) {
                  //console.log(host.publicPage.route)
                  //console.log(to);
                  if(to.path!=undefined)
                    setRedirectUrl(to.path);


                  next({
                    name: host.publicPage.route,
                    params: {
                      id: store.state.app.homePageId,
                      cid: 0
                    }
                  });
                }
              });
            //# umnu iim bsan
            // next({
            //   name: host.publicPage.route
            // })
          } else {
            //console.log("publicPage has 3")
            turnLogin(to, next, true);
          }
        });
    } else {
      //console.log("end irsen uu", to.name)
      if(to.name=="login"){
        manageMainLayoutConfig(to, store, true, true);
      }
      //console.log('externalPages',externalPages);
      if (hasOneOf(externalPages, [to.name])) {
        store
          .dispatch("handleJWT", {
            key: host.key
          })
          .then(JWT => {
            if (JWT != false) {
              next();
            } else {
              turnLogin(to, next);
              //ene uyed neg tiim 500 ch yumuu huudas ruu shideh
            }
          });
      } else if ("login" == to.name) {
        turnLogin(to, next);
      } else {
        turnLogin(to, next, true);
      }

      // store.dispatch('handleJWT', {
      //   key: host.key
      // }).then(JWT => {
      //   if (JWT != false){

      //   }
      //   else{
      //     //ene uyed neg tiim 500 ch yumuu huudas ruu shideh
      //   }
      // })
    }
  } else {
    //console.log('token bgaa ni', host.publicPage);
    //console.log('token bgaa ni', host);
    //console.log("tokentai")
    //console.log(to, to.meta);
    if (to.matched.length == 0) {
      //console.error("tom 0")
      store
        .dispatch("handleRoutes", {
          router
        })
        .then(res => {
          let toPath = findRouteNameByPath(res, to.path);
          // console.log("route finded", res, toPath, to.path);
          let profRoute = findRouteNameByPath(res, "/user/profile");
          //let invoiceRoute=undefined;
          let invoiceRoute = undefined;
          
          //console.log("tooooooooooooooooooooooo",to.path);
          
          if(!to.path.startsWith("/lms/paymentDetail")){
            //console.log("nuhtsul orson uu");
            invoiceRoute = findRouteNameByPath(res, "/lms/paymentDetail/:id");
          }
            

          let minv = parseInt(
            getConfigValueByKey(store.state.app.groupSettings, "anketReqPerc"),
            10
          );
          let checkminv = parseInt(
            getConfigValueByKey(
              store.state.app.groupSettings,
              "anketCheckPerc"
            ),
            10
          );

          //console.log(invoiceRoute);

          if (toPath != "") {
            if (toPath.meta.login) {
              if (store.state.user.userId != "") {
                // if ( (store.state.app.activeGroup.id == 9241 || store.state.app.activeGroup.id == 9249) && store.state.user.userInfo.locType4Code == 'register' ) {
                //   let coursesRoute = findRouteNameByPath(res, "/lms/paymentDetail/:id");
                //   turnTo(coursesRoute, store.state.user.access, next, true);
                // }

                if (
                  (store.state.app.activeGroup.id == 9235 || store.state.app.activeGroup.id == 9351 || store.state.app.activeGroup.id == 9290 || store.state.app.activeGroup.id == 9272) &&
                  !store.state.user.userInfo.userLicense.isActive
                ) {
                  invoiceRoute.params.id =
                    store.state.user.userInfo.userLicense.invoiceId;
                  turnTo(invoiceRoute, store.state.user.access, next, true);
                }
                if (
                  hasOneOf(["learningstudent"], store.state.user.access) &&
                  checkminv == 1 &&
                  minv > store.state.user.userInfo.anketTotal
                ) {
                  turnTo(profRoute, store.state.user.access, next, true);
                } else {
                  turnTo(toPath, store.state.user.access, next, true);
                }
              } else {
                store
                  .dispatch("handleUserInfo", {
                    store: store
                  })
                  .then(user => {
                    if (user != false) {
                      if (user.data.user_id == "") {
                        //console.log("ene 1");
                        turnLogin(toPath, next, true);
                      } else {
                        store
                          .dispatch("handleGroupSettings", {
                            store: store
                          })
                          .then(sett => {
                            if (sett != false) {
                              store
                                .dispatch("handleUsersettings", {
                                  store: store
                                })
                                .then(ustt => {
                                  if (ustt != false) {
                                    store
                                      .dispatch("handleGroupDefaultProjects", {
                                        store: store
                                      })
                                      .then(projects => {
                                        if (projects != false) {
                                          //console.log(store.state.app.activeGroup)
                                          if (
                                            (store.state.app.activeGroup.id ==
                                              9351 || store.state.app.activeGroup.id ==
                                              9235 || store.state.app.activeGroup.id ==
                                              9290 || store.state.app.activeGroup.id == 9272) &&
                                            !store.state.user.userInfo
                                              .userLicense.isActive
                                          ) {
                                            invoiceRoute.params.id =
                                              store.state.user.userInfo.userLicense.invoiceId;
                                            turnInvoice(
                                              to,
                                              next,
                                              invoiceRoute.params.id
                                            );
                                          }

                                          minv = parseInt(
                                            getConfigValueByKey(
                                              store.state.app.groupSettings,
                                              "anketReqPerc"
                                            ),
                                            10
                                          );
                                          checkminv = parseInt(
                                            getConfigValueByKey(
                                              store.state.app.groupSettings,
                                              "anketCheckPerc"
                                            ),
                                            10
                                          );
                                          if (
                                            hasOneOf(
                                              ["learningstudent"],
                                              store.state.user.access
                                            ) &&
                                            checkminv == 1 &&
                                            minv >
                                              store.state.user.userInfo
                                                .anketTotal
                                          ) {
                                            store
                                              .dispatch("handleSignalR", {})
                                              .then(() => {
                                                turnProfile(to, next);
                                              })
                                              .catch(() => {
                                                turnProfile(to, next);
                                              });
                                          } else {
                                            store
                                              .dispatch("handleSignalR", {})
                                              .then(() => {
                                                turnTo(
                                                  toPath,
                                                  store.state.user.access,
                                                  next,
                                                  true
                                                );
                                              })
                                              .catch(() => {
                                                turnTo(
                                                  toPath,
                                                  store.state.user.access,
                                                  next,
                                                  true
                                                );
                                              });
                                          }
                                        } else {
                                          //console.log("ene 2");
                                          turnLogin(toPath, next, true);
                                        }
                                      });
                                  } else {
                                    //console.log("ene 3");
                                    turnLogin(toPath, next, true);
                                  }
                                });
                            } else {
                              //console.log("ene 4");
                              turnLogin(toPath, next, true);
                            }
                          });
                      }
                    } else {
                      //console.log("ene 5");
                      turnLogin(toPath, next, true);
                    }
                  })
                  .catch(() => {
                    //console.log("ene 6");
                    turnLogin(toPath, next, true);
                  });
              }
            } else {
              turnTo(toPath, store.state.user.access, next, true);
            }
          } else {
            //console.log("ene 7");
            if(to.path!=undefined)
                setRedirectUrl(to.path);
            turnLogin(toPath, next, true);
          }
        });
    } else if (to.meta.login) {
      //console.log("tom 1")
      let invoiceRoute = findRouteNameByPath(
        store.state.app.dynamicRoutes,
        "/lms/paymentDetail/:id"
      );
      let profRoute = findRouteNameByPath(
        store.state.app.dynamicRoutes,
        "/user/profile"
      );
      let minv = parseInt(
        getConfigValueByKey(store.state.app.groupSettings, "anketReqPerc"),
        10
      );
      let checkminv = parseInt(
        getConfigValueByKey(store.state.app.groupSettings, "anketCheckPerc"),
        10
      );
      //console.log("what is ", invoiceRoute, from.name)
      if (store.state.user.userId != "") {
        //console.log('*************************************** 1');
        if(host.limitedRoutes != undefined && host.limitedRoutes.length>0 && to.name!=host.limitedRoutes[0]) {
          //console.log('*************************************** 2');
          turnTo({name: host.limitedRoutes[0]}, store.state.user.access, next, true);
        }
        else if (
          (store.state.app.activeGroup.id == 9351 || store.state.app.activeGroup.id == 9235 || store.state.app.activeGroup.id == 9290 || store.state.app.activeGroup.id == 9272) &&
          !store.state.user.userInfo.userLicense.isActive
        ) {
          //console.log('*************************************** 3');
          invoiceRoute.params.id =
            store.state.user.userInfo.userLicense.invoiceId;

          if (invoiceRoute.name == from.name) {
            store.dispatch("handleLoading", {
              isLoading: false
            });
            next(false);
          } else {
            if (to.name == "lmsPaymentDetail")
              turnTo(to, store.state.user.access, next);
            //next(false)
            else turnInvoice(to, next, invoiceRoute.params.id);
          }
        } else if (
          hasOneOf(["learningstudent"], store.state.user.access) &&
          checkminv == 1 &&
          minv > store.state.user.userInfo.anketTotal
        ) {
          //console.log('*************************************** 4');
          if (profRoute.name == from.name) {
            store.dispatch("handleLoading", {
              isLoading: false
            });
            next(false);
          } else {
            if (to.name == "userProfile")
              turnTo(to, store.state.user.access, next);
            else turnProfile(to, next);
          }
        } else {
          //console.log('*************************************** 5');
          turnTo(to, store.state.user.access, next);
        }
        //turnTo(to, store.state.user.access, next)
      } else {
        store
          .dispatch("handleUserInfo", {
            store: store
          })
          .then(user => {
            if (user != false) {
              if (user.data.user_id == "") {
                turnLogin(to, next, true);
              } else {
                store
                  .dispatch("handleGroupDefaultProjects", {
                    store: store
                  })
                  .then(projects => {
                    if (projects != false) {
                      store
                        .dispatch("handleRoutes", {
                          router: router
                        })
                        .then(() => {
                          minv = parseInt(
                            getConfigValueByKey(
                              store.state.app.groupSettings,
                              "anketReqPerc"
                            ),
                            10
                          );
                          checkminv = parseInt(
                            getConfigValueByKey(
                              store.state.app.groupSettings,
                              "anketCheckPerc"
                            ),
                            10
                          );
                          if (
                            (store.state.app.activeGroup.id == 9351 || store.state.app.activeGroup.id == 9235 || store.state.app.activeGroup.id == 9290 || store.state.app.activeGroup.id == 9272) &&
                            !store.state.user.userInfo.userLicense.isActive
                          ) {
                            invoiceRoute.params.id =
                              store.state.user.userInfo.userLicense.invoiceId;
                            turnTo(
                              invoiceRoute,
                              store.state.user.access,
                              next,
                              true
                            );
                          }
                          if (
                            hasOneOf(
                              ["learningstudent"],
                              store.state.user.access
                            ) &&
                            checkminv == 1 &&
                            minv > store.state.user.userInfo.anketTotal
                          ) {
                            store
                              .dispatch("handleSignalR", {})
                              .then(() => {
                                turnTo(
                                  profRoute,
                                  store.state.user.access,
                                  next
                                );
                              })
                              .catch(() => {
                                turnTo(
                                  profRoute,
                                  store.state.user.access,
                                  next
                                );
                              });
                          } else {
                            store
                              .dispatch("handleSignalR", {})
                              .then(() => {
                                turnTo(to, store.state.user.access, next);
                              })
                              .catch(() => {
                                turnTo(to, store.state.user.access, next);
                              });
                          }
                        })
                        .catch(() => {
                          turnLogin(to, next, true);
                        });
                    } else {
                      turnLogin(to, next, true);
                    }
                  });
              }
            } else {
              turnLogin(to, next, true);
            }
          })
          .catch(() => {
            turnLogin(to, next, true);
          });
      }
    } else {
      //console.log("tom 2")
      if (
        host.publicPage != undefined &&
        host.publicPage.has &&
        store.state.user.userId == ""
      ) {
        if (
          host.publicPage.route == to.name ||
          (to.name == "login" && from.name != null) ||
          to.name == "login" ||
          to.name == "vetLandingMeds" ||
          to.name == "vetLandingLics" ||
          to.name == "vetLandingHelp"
        ) {
          if (store.state.app.pages.length > 0) {
            //console.log("step 1", to);
            turnTo(to, store.state.user.access, next);
            // next({
            //   name: host.publicPage.route,
            //   params: { id: store.state.app.homePageId }
            // })
          } else {
            //console.log("step 1");
            //console.log('step 2', to);
            store
              .dispatch("handlePages", {
                store: store
              })
              .then(page => {
                if (page != false) {
                  turnTo(to, store.state.user.access, next);
                  // next({
                  //   name: host.publicPage.route,
                  //   params: { id: store.state.app.homePageId }
                  // })
                }
              });
          }
          //next()
          //turnTo(to, store.state.user.access, next);
        } else {
          // next({
          //   name: host.publicPage.route,
          //   params: {id: store.state.app.homePageId }
          // });
          //console.log('externalPages', externalPages);
          if (hasOneOf(externalPages, [to.name])) {
            //console.log(to);
            //console.log("register bolon activation ruu nextley")
            //console.log("1",to);
            manageMainLayoutConfig(to, store, true, true);
            next();
          } else {
            to.name = host.publicPage.route;
            to.params = {
              id: store.state.app.homePageId,
              cid: 0
            };
            turnTo(to, store.state.user.access, next, true);

            //turnTo(to, store.state.user.access, next, true);
          }
        }
      } else {
        //next();
        //console.log("what is this", to.name);
        //console.log('externalPages', externalPages);
        //console.log('1111111 1111111 1111111 1111111 1111111 1111111 1111111 1111111 1111111 1111111 ', externalPages.some(_ => [to.name].indexOf(_) > -1));
        
        if (hasOneOf(externalPages, [to.name])) {
          //console.log("2",to);
          //console.log("register bolon activation ruu nextley")
          manageMainLayoutConfig(to, store, true, true);
          next();
        } else {
          turnLogin(to, next, true);
          //turnTo(to, store.state.user.access, false);
        }
      }
    }
  }
});

router.afterEach((to, from, next) => {
  // if(to.name!=undefined && to.name!=''){
  //   if(to.name != 'lmsCourses'){
  //console.log('odoo tseverle !!!');
  //   }
  // }
//router.afterEach((to, from ,next)) => {
  store.dispatch("handleLoading", {
    isLoading: false
  });
  window.scrollTo(0, 0);
  // for (const route of to.matched) {
  //   if (route.params !=undefined && route.params.bot==500 && route.params.iid>0) {
  //     zoombt.use();
  //     zoomrs.use();
  //   }
  //   // else{
  //   //   zoombt.unuse();
  //   //   zoomrs.unuse();
  //   // }
  // }
});

export default router;
